import React from "react";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import { SALE_MOVIE_PAGE } from "../../routes";
import { RiEmotionSadFill } from "react-icons/ri";
import { useTranslation } from "react-i18next";

const PurchaseFailed: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="purchase-failed flex-center-center">
      <div className="block shadow flex-center-center flex-wrap">
        <div className="failed-purchase-icon flex-center-center">
          <RiEmotionSadFill className="icon" />
        </div>
        <h1>{t("platnosc_nie_powiodla_sie")}</h1>
        <p>{t("cos_poszlo_nie_tak_sprobuj_ponownie")}</p>
        <div className="button-group-failed">
          <div className="button-group-second-row-failed">
            <button onClick={() => navigate(SALE_MOVIE_PAGE)}>{t("zacznij_zakupy_od_nowa")}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseFailed;
